import { Close } from "@mui/icons-material";
import { Dialog, DialogContent, DialogTitle, IconButton, Slide, Stack, Typography } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React, { ReactElement } from "react";
import { NewsData } from "../../Objects/NewsDate";
import NewsImage from "../atoms/NewsImage";


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />
})

export interface NewsDetailDialogProps {
    newsData?: NewsData
    onClose: () => void
}

const NewsDetailDialog: React.FC<NewsDetailDialogProps> = ({
    newsData,
    onClose,
}) => {

    const [open, setOpen] = React.useState<boolean>(false)

    /**
     * データ初期化
     */
    React.useEffect(() => {
        if (newsData) {
            setOpen(true)
        } else {
            setOpen(false)
        }
    }, [newsData])

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            onClose={() => {
                setOpen(false)
            }}
            TransitionProps={{
                onExited: () => {
                    onClose()
                }
            }}
            fullWidth
        >
            <DialogTitle>
                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                >
                    <Typography>{newsData && newsData.title}</Typography>
                    <IconButton
                        onClick={() => {
                            setOpen(false)
                        }}
                    >
                        <Close />
                    </IconButton>
                </Stack>
            </DialogTitle>
            {newsData &&
                <DialogContent>
                    <Stack
                        spacing={2}
                    >
                        <NewsImage newsData={newsData} />
                        <Typography
                            variant="body1"
                            whiteSpace={"pre-wrap"}
                        >{newsData.news_detail}</Typography>
                    </Stack>
                </DialogContent>
            }
        </Dialog>
    );
}

export default NewsDetailDialog